import { REGISTER_STEPS } from "./register.constants.ts";

/**
 * The step markers. Same props and same reason as SignupSteps: `current` drives
 * the highlight, and anything before it is complete.
 */
export function RegisterSteps({ current }: { current: number }) {
  return (
    <ol className="register__steps">
      {REGISTER_STEPS.map((label, index) => {
        const state =
          index < current ? "done" : index === current ? "current" : "todo";

        return (
          <li key={label} className={`register__step register__step--${state}`}>
            <span className="register__step-mark" aria-hidden="true">
              {index < current ? "✓" : index + 1}
            </span>
            <span className="register__step-label">{label}</span>
          </li>
        );
      })}
    </ol>
  );
}
